import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AppProvider } from "./providers/AppProvider";
import { AppRoutes } from "./routes";
const App = () => {
    return (_jsx(AppProvider, { children: _jsx(AppRoutes, {}) }));
};
export default App;
